import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { CatalogStatusEntry } from "@/pages/products/hooks/useProductCatalogStatus";

interface DelistSuggestionsProps {
  items: CatalogStatusEntry[];
  category?: string | null;
  // 提供 onPick 时渲染为按钮（就地选入表单）；否则渲染为跳转链接。
  onPick?: (slug: string) => void;
}

export default function DelistSuggestions({ items, category, onPick }: DelistSuggestionsProps) {
  const { t } = useTranslation();
  if (items.length === 0) return null;

  return (
    <div className="mt-3 rounded-md border border-background-200 bg-background-50/70 p-3">
      <p className="flex items-center gap-1.5 text-xs font-medium text-foreground-800">
        <span className="flex h-3.5 w-3.5 items-center justify-center text-primary-600">
          <i className="ri-lightbulb-line" />
        </span>
        {category ? t("products.recSameCategory", { category }) : t("products.recGeneric")}
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        {items.map((item) =>
          onPick ? (
            <button
              key={item.id}
              type="button"
              onClick={() => onPick(item.slug)}
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700 transition-colors hover:border-primary-300 hover:bg-primary-100"
            >
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-apps-2-line" />
              </span>
              {item.name}
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </button>
          ) : (
            <Link
              key={item.id}
              to={`/apply?product=${item.slug}`}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700 transition-colors hover:border-primary-300 hover:bg-primary-100"
            >
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-apps-2-line" />
              </span>
              {item.name}
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          ),
        )}
      </div>
    </div>
  );
}